export default "__VITE_ASSET__905f45a2__"